import React, { useState } from "react";

import ReplaceCentral from "./ReplaceCentral";

import { InspectorContextProvider } from "contexts/Inspector";
const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "ReplaceCentral",
    props: null
  });

  return (
    <InspectorContextProvider>
      <SwitchComponents active={pageProps.active}>
        <ReplaceCentral
          name="ReplaceCentral"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </InspectorContextProvider>
  );
};

export default Index;
